export default function ProductosMenu({ idioma }) {
  return (
    <iframe
      src={
        idioma === 'es'
          ? 'https://docs.terramarbrandsusa.com/legales/Lineamientos_para_los_Testimonios_de_Producto_ESP.pdf'
          : 'https://docs.terramarbrandsusa.com/legales/Lineamientos_para_los_Testimonios_de_Producto_ING.pdf'
      }
      style={{ width: '100%', height: '100%' }}
      frameBorder='0'
      title='framelegales'
    />
  );
}
